import { ProviderRoleId } from '../currentRole'
import defaultLayout from './defaultLayout'
import { LayoutDefinition, LayoutEntry } from './layout'
import { PLAN_PANELS, PLAN_ROLES, PlanRole } from './registry'

const isPlanRole = (role: ProviderRoleId): role is PlanRole => PLAN_ROLES.some((planRole) => planRole === role)

// The psychiatrist's editor is Care Plan tab only, never on Progress.
const layoutFor = (role: PlanRole): LayoutDefinition => {
  const ownEditor: LayoutEntry[] = role === 'psychiatrist' ? [] : [{ panel: PLAN_PANELS[role].editor, span: 'full' }]
  const othersPlans: LayoutEntry[] = PLAN_ROLES.filter((other) => other !== role).map((other) => ({
    panel: PLAN_PANELS[other].viewer,
    span: 'half',
  }))

  return { panels: [...defaultLayout.panels, ...ownEditor, ...othersPlans] }
}

// Built once: `useDashboardLayout` depends on the fallback, so a fresh object per render loops.
const LAYOUTS = PLAN_ROLES.reduce(
  (layouts, role) => ({ ...layouts, [role]: layoutFor(role) }),
  {} as Record<PlanRole, LayoutDefinition>
)

export const defaultLayoutForRole = (role: ProviderRoleId): LayoutDefinition =>
  isPlanRole(role) ? LAYOUTS[role] : defaultLayout
